import { render, staticRenderFns } from "./FrameManual.vue?vue&type=template&id=7fdc7fa5"
import script from "./FrameManual.vue?vue&type=script&lang=js"
export * from "./FrameManual.vue?vue&type=script&lang=js"
import style0 from "./FrameManual.vue?vue&type=style&index=0&id=7fdc7fa5&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports